import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          meta: {
            keywords: 'ai recipe generator, what to cook, recipe by ingredients, smart food planner, cooking app, personalized recipes, healthy eating, meal planning, video recipes, food waste reduction, smart pantry'
          },
          header: {
            features: 'Features',
            recipes: 'Recipes',
            download: 'Download',
            contact: 'Contact',
          },
          hero: {
            title: 'Create Unique Recipes in Seconds with Artificial Intelligence',
            description: 'Change your cooking routine. Don\'t worry about what to cook with the ingredients you have; with FoodQuick\'s smart artificial intelligence, hundreds of special video and practical recipes are instantly at your fingertips. Join the revolution in the kitchen!',
            freeDownload: 'Free Download and Start',
            discoverMore: 'Discover More',
            videoRecipes: 'Video Recipes',
            aiSuccessRate: 'AI Success Rate',
            userRating: 'User Rating',
          },
          features: {
            title: 'Your Superpower in the Kitchen',
            subtitle: 'FoodQuick is packed with smart features that make cooking easier, more personal, and fun. Here are just a few of what await you:',
            feature1_title: 'AI Recipe Generator',
            feature1_description: 'Take a picture or select your ingredients, and let the AI create hundreds of custom recipes for you in seconds.',
            feature2_title: 'Smart Pantry Management',
            feature2_description: 'Add your ingredients at home to your digital pantry, automatically create your shopping list, and prevent food waste.',
            feature3_title: 'Personalized Taste Profile',
            feature3_description: 'Specify your dietary preferences, allergies, and favorite tastes, and enjoy recommendations tailored just for you.',
            feature4_title: 'Extensive Video Library',
            feature4_description: 'Cook even the most challenging dishes step-by-step, easily and enjoyably, with over 1000 HD video recipes.',
            feature5_title: 'Nutritional Value and Calorie Tracking',
            feature5_description: 'Reach your healthy living goals by learning the calorie and nutritional values of every meal you eat.',
            feature6_title: 'Smart Portion Calculator',
            feature6_description: 'Easily adjust recipes for 2 to 8 servings based on the number of your guests, without worrying about ingredient quantities.',
          },
          recipes: {
            title: 'AI\'s Culinary Marvels',
            subtitle: 'Check out these practical and delicious recipes selected for you by FoodQuick\'s artificial intelligence.',
            viewRecipe: 'View Recipe',
            cuisines: {
              turkish: 'Turkish',
              american: 'American',
              italian: 'Italian',
              french: 'French',
            },
            difficulties: {
              easy: 'Easy',
              medium: 'Medium',
              hard: 'Hard',
            },
            categories: {
              dessert: 'Dessert',
              breakfast: 'Breakfast',
              lunch: 'Lunch',
              dinner: 'Dinner',
              soup: 'Soup',
              pastry: 'Pastry',
            },
            time_unit: 'min',
          },
          download: {
            title: 'Join the Revolution in the Kitchen!',
            subtitle: 'Rediscover the cooking experience with artificial intelligence. Download FoodQuick now for free and create your first smart recipe in seconds.'
          },
          footer: {
            privacyPolicy: 'Privacy Policy',
            terms: 'Terms',
            contact: 'Contact',
            copyright: '© {{year}} FoodQuick. All rights reserved.'
          },
          recipeDetail: {
            loading: 'Loading recipe...',
            error: 'Could not load the recipe.',
            ingredients: 'Ingredients',
            instructions: 'Instructions',
            ingredient1: 'Ingredient 1',
            ingredient2: 'Ingredient 2',
            ingredient3: 'Ingredient 3',
            step1: 'Step 1',
            step2: 'Step 2',
            step3: 'Step 3'
          }
        }
      },
      tr: {
        translation: {
          meta: {
            keywords: 'yapay zeka yemek tarifleri, ne pişirsem, malzemeye göre tarif, akıllı yemek planlayıcı, yemek uygulaması, kişiselleştirilmiş tarifler, sağlıklı beslenme, yemek planlama, videolu tarifler, gıda israfını önleme, akıllı kiler'
          },
          header: {
            features: 'Özellikler',
            recipes: 'Tarifler',
            download: 'İndir',
            contact: 'İletişim',
          },
          hero: {
            title: 'Yapay Zeka ile Saniyeler İçinde Benzersiz Tarifler Yaratın',
            description: 'Yemek yapma rutinini değiştir. Elindeki malzemelerle ne pişireceğini düşünme, FoodQuick\'in akıllı yapay zekasıyla sana özel yüzlerce videolu ve pratik tarif anında elinin altında. Mutfakta devrime sen de katıl!',
            freeDownload: 'Ücretsiz İndir ve Başla',
            discoverMore: 'Daha Fazlasını Keşfet',
            videoRecipes: 'Video Tarif',
            aiSuccessRate: 'AI Başarı Oranı',
            userRating: 'Kullanıcı Puanı',
          },
          features: {
            title: 'Mutfaktaki Süper Gücünüz',
            subtitle: 'FoodQuick, yemek yapmayı kolaylaştıran, kişiselleştiren ve eğlenceli hale getiren akıllı özelliklerle dolu. İşte sizi bekleyenlerden sadece birkaçı:',
            feature1_title: 'Yapay Zeka Tarif Üretici',
            feature1_description: 'Malzemelerinin fotoğrafını çek veya seç, yapay zeka saniyeler içinde sana özel yüzlerce tarif hazırlasın.',
            feature2_title: 'Akıllı Kiler Yönetimi',
            feature2_description: 'Evdeki malzemelerini dijital kilerine ekle, alışveriş listeni otomatik oluştur ve gıda israfını önle.',
            feature3_title: 'Kişiselleştirilmiş Damak Profili',
            feature3_description: 'Diyet tercihlerini, alerjilerini ve sevdiğin tatları belirt, sadece sana uygun önerilerin tadını çıkar.',
            feature4_title: 'Geniş Video Kütüphanesi',
            feature4_description: '1000 den fazla HD video tarif ile en zor yemekleri bile adım adım, kolayca ve eğlenerek pişir.',
            feature5_title: 'Besin Değeri ve Kalori Takibi',
            feature5_description: 'Yediğin her yemeğin kalorisini ve besin değerlerini öğrenerek sağlıklı yaşam hedeflerine ulaş.',
            feature6_title: 'Akıllı Porsiyon Hesaplayıcı',
            feature6_description: 'Tarifleri misafir sayına göre 2 ila 8 porsiyon arasında kolayca ayarla, malzeme miktarını dert etme.',
          },
          recipes: {
            title: 'Yapay Zekanın Mutfak Harikaları',
            subtitle: 'FoodQuick\'in yapay zekasının sizin için seçtiği, hem pratik hem de damak çatlatan tariflere göz atın.',
            viewRecipe: 'Tarifi İncele',
            cuisines: {
              turkish: 'Türk',
              american: 'Amerikan',
              italian: 'İtalyan',
              french: 'Fransız',
            },
            difficulties: {
              easy: 'Kolay',
              medium: 'Orta',
              hard: 'Zor',
            },
            categories: {
              dessert: 'Tatlı',
              breakfast: 'Kahvaltı',
              lunch: 'Öğle Yemeği',
              dinner: 'Akşam Yemeği',
              soup: 'Çorba',
              pastry: 'Hamur İşi',
            },
            time_unit: 'dk',
          },
          download: {
            title: 'Mutfaktaki Devrime Katılın!',
            subtitle: 'Yapay zeka ile pişirme deneyimini yeniden keşfedin. FoodQuick\'i şimdi ücretsiz indirin ve ilk akıllı tarifinizi saniyeler içinde oluşturun.'
          },
          footer: {
            privacyPolicy: 'Gizlilik Politikası',
            terms: 'Şartlar',
            contact: 'İletişim',
            copyright: '© {{year}} FoodQuick. Tüm hakları saklıdır.'
          },
          recipeDetail: {
            loading: 'Tarif yükleniyor...',
            error: 'Tarif yüklenemedi.',
            ingredients: 'Kullanılan Malzemeler',
            instructions: 'Yapılışı',
            ingredient1: 'Malzeme 1',
            ingredient2: 'Malzeme 2',
            ingredient3: 'Malzeme 3',
            step1: '1. Adım',
            step2: '2. Adım',
            step3: '3. Adım'
          }
        }
      }
    }
  });

export default i18n;
